import * as yup from 'yup';

export const NotificationSettingsFormSchema = yup.object().shape({
  reportNotificationEnabled: yup.boolean().nullable(),
  reportNotificationRecipients: yup.array().of(yup.string().email()).nullable(),
});
